import {signal} from "@preact/signals-react";

export const monitoringResultsIsEmpty = signal(false)
export const monitoringResultsReportFormIsOpen = signal(false)
export const monitoringResultsReportFormSubmittedFilters = signal({})
export const monitoringResultsTableBrandFilter = signal(null)
export const monitoringResultsTableEANFilter = signal([])
export const monitoringResultsTableRefFilter = signal([])
export const monitoringResultsTableProductFilter = signal([])
export const monitoringResultsTableFirstMoverFilter = signal([])
export const monitoringResultsTableUnderPriceFilter = signal([])
export const monitoringResultsTableRestockedFilter = signal([])
export const monitoringResultsTableOutOfStockFilter = signal([])
export const monitoringResultsDataLimit = signal(false)
export const monitoringResultsReportIssueData = signal({})
export const monitoringResultsRefreshDataModalIsOpen = signal(false)
export const monitoringResultsScopeFilters = signal({})

export const resetMonitoringResults = () => {
    monitoringResultsIsEmpty.value = false
    monitoringResultsReportFormIsOpen.value = false
    monitoringResultsReportFormSubmittedFilters.value =  {}
    monitoringResultsDataLimit.value = false
    monitoringResultsReportIssueData.value = {}
    monitoringResultsScopeFilters.value = {}
}